<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('button.details')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="editRecord"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('button.delete')" position="top">
                <feather-icon icon="TrashIcon" class="action-err icon-btn"
                              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                              @click="confirmDeleteRecord"/>
            </vx-tooltip>
        </div>

        <vs-popup class="holamundo"  title="Thông tin chi tiết" :active.sync="popupDetails" v-if="popupDetails" id="details-teacher-interac">
            <TeacherInteractionInfo :detailsId="params.data.id"></TeacherInteractionInfo>
        </vs-popup>
    </div>
</template>

<script>

import TeacherInteractionInfo from "../TeacherInteractionInfo"

export default {
    name: "CellRendererActions",
    components: {
        TeacherInteractionInfo
    },
    data() {
        return {
            popupDetails: false,
        }
    },
    methods: {
        editRecord() {
            this.popupDetails = true
        },

        confirmDeleteRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá bản ghi này không ?`,
                accept: this.deleteRecord,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },
        deleteRecord() {
            this.$vs.loading();
            this.$crm.delete('/teacher-interaction/delete/' + this.params.data.id).then(() => {
                this.$vs.loading.close();
                this.showDeleteSuccess();
                this.$store.commit('UPDATE_TEACHER_INTERACTION', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showDeleteSuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xoá thành công',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    },
}
</script>

<style lang="scss">
#details-teacher-interac {
    .vs-popup {
        width: 1000px;
    }
}
</style>
